import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Pf16Service } from 'src/app/services/pf16.service';
import Swal from 'sweetalert2';



@Component({
  selector: 'app-create-pf16',
  templateUrl: './create-pf16.component.html',
  styleUrls: ['styles.css'
  ]
})
export class CreatePf16Component implements OnInit {

  public pf16Form = this.fb.group({
    title: ['', Validators.required],
    opcA: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    opcB: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    opcC: this.fb.group({
      text:[''],
      value:[0]
    }) ,
    factor: [''],
  });

  constructor(private fb: FormBuilder, private pf16Service: Pf16Service) { }

  ngOnInit(): void {
  }

  reset(){
    this.pf16Form.reset();
  }

  register(){
    this.pf16Service.createQuestion(this.pf16Form.value).subscribe(
      resp=>{
        console.log(resp);
        Swal.fire('Pregunta creada');
        window.location.reload();
      },
      err=>console.log(err)
    )
  }

}
